$(document).ready(function() {
  $('body').on('click', '.show-toggle', function(e) {
    console.log('$(this)', $(this).parents('.list-order'))
    $(this).parents('.list-order').toggleClass('show-all')
  })
})